export class TextBuilder {
  parts: (string | JSX.Element)[] = []
  text: string = ''
  constructor() {}
  add(text: string | JSX.Element): TextBuilder {
    this.parts.push(text)
    return this
  }
  get(): (string | JSX.Element)[] {
    return this.parts
  }
  clear(): TextBuilder {
    this.parts = []
    return this
  }
  decide_by_index(index: number, options: (string | JSX.Element)[]) {
    this.add(options[index])
    return this
  }
  decide_by_indexgroup(
    index: number,
    options: [number[], string | JSX.Element][],
    other?: string | JSX.Element
  ) {
    for (let option of options) {
      if (option[0].includes(index)) {
        this.add(option[1])
        return this
      }
    }
    if (other) this.add(other)
    return this
  }

  decide_by_range(
    value: number,
    options: [[number, number], string | JSX.Element][]
  ) {
    for (let option of options) {
      if (value >= option[0][0] && value < option[0][1]) {
        this.add(option[1])
        return this
      }
    }
    return this
  }
}
